
import React from 'react';
import { TimerIcon } from './icons/TimeIcons';
import { CoffeeIcon, SofaIcon } from './icons/ActivityIcons';

interface SequenceIndicatorProps {
  sessions: number;
  currentSession: number;
  currentType: 'pomodoro' | 'shortBreak' | 'longBreak';
  isMobile?: boolean;
  activeIndex?: number;
}

// RESTORED CLEAN SEQUENCE INDICATOR
const SequenceIndicator: React.FC<SequenceIndicatorProps> = ({
  sessions,
  currentSession,
  currentType,
  isMobile = false,
  activeIndex: explicitActiveIndex = -1
}) => {
  // Generate sequence: alternating work/breaks + final long break
  const generateSequence = () => {
    const sequence: ('pomodoro' | 'shortBreak' | 'longBreak')[] = [];
    for (let i = 0; i < sessions; i++) {
      sequence.push('pomodoro');
      if (i === sessions - 1) sequence.push('longBreak');
      else sequence.push('shortBreak');
    }
    return sequence;
  };
  const sequence = generateSequence();

  // Which icon is "active"
  const determineActiveIndex = () => {
    if (currentType === 'pomodoro') return currentSession * 2;
    if (currentType === 'shortBreak') return (currentSession * 2) + 1;
    if (currentType === 'longBreak') return sequence.length - 1;
    return 0;
  };
  const activeIndex = explicitActiveIndex >= 0 ? explicitActiveIndex : determineActiveIndex();

  // Icon rendering
  const getIcon = (type: 'pomodoro' | 'shortBreak' | 'longBreak', index: number) => {
    const size = isMobile ? 18 : 22;
    const isActive = index <= activeIndex;
    const isCurrent = index === activeIndex;
    const color = isActive ? "white" : "rgba(255,255,255,0.5)";
    const strokeWidth = isCurrent ? 2 : 1.5;
    switch (type) {
      case 'pomodoro':
        return <TimerIcon size={size} color={color} strokeWidth={strokeWidth} />;
      case 'shortBreak':
        return <CoffeeIcon size={size} color={color} strokeWidth={strokeWidth} />;
      case 'longBreak':
        return <SofaIcon size={size} color={color} strokeWidth={strokeWidth} />;
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between w-full">
        {sequence.map((type, idx) => (
          <React.Fragment key={idx}>
            <div
              className={`
                flex items-center justify-center
                transition-all duration-300
                ${activeIndex === idx ? 'scale-110 opacity-100' : idx < activeIndex ? 'opacity-100' : 'opacity-50'}
                ${idx === 0 ? 'pl-0' : ''} ${idx === sequence.length-1 ? 'pr-0' : ''}
              `}
              style={{ minWidth: isMobile ? 18 : 22 }}
            >
              {getIcon(type, idx)}
            </div>
            {idx < sequence.length - 1 && (
              <div
                className={`
                  rounded-full transition-colors duration-300
                  ${idx < activeIndex ? 'bg-white' : 'bg-white/40'}
                  flex-1
                `}
                style={{
                  height: 2,
                  minWidth: isMobile ? 7 : 10,
                  marginLeft: isMobile ? 2 : 4, // Optional: adds breathing room
                  marginRight: isMobile ? 2 : 4
                }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SequenceIndicator;
